import React, { useRef, useEffect } from "react";
import * as THREE from "three";
import useStore from "../store";
import { extend, useThree, useFrame, useRender } from "react-three-fiber";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass";
import { FilmPass } from "three/examples/jsm/postprocessing/FilmPass";
import GaussianBlurShader from "../shaders/GaussianBlurShader";

extend({ EffectComposer, ShaderPass, RenderPass, UnrealBloomPass, FilmPass });

export default function Effects() {
  const { blur } = useStore((state) => state.debug);
  const composer = useRef();
  const { scene, gl, size, camera } = useThree();

  useEffect(() => void composer.current.setSize(size.width, size.height), [
    size,
  ]);

  useFrame(() => composer.current.render(), 2);

  useRender(() => {
    gl.shadowMap.type = THREE.PCFSoftShadowMap;
    gl.shadowMap.enabled = true;
  });

  return (
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      <unrealBloomPass attachArray="passes" args={[undefined, 0.5, 1, 0]} />
      <shaderPass
        attachArray="passes"
        args={[GaussianBlurShader]}
        material-uniforms-resolution-value={[size.width, size.height]}
        material-uniforms-strength-value={blur}
      />
    </effectComposer>
  );
}
